import request from '@/utils/request'

let AdvApi = {
  /*广告列表*/
   advList(data, errorback) {
    return request._post('/shop/plus.adv.adv/index', data, errorback);
  },
  /*添加广告*/
  addAdv(data, errorback) {
    return request._post('/shop/plus.adv.adv/add', data, errorback);
  },
  /*获取广告数据*/
  getAdv(data, errorback) {
    return request._get('/shop/plus.adv.adv/edit', data, errorback);
  },
 
  /*保存广告*/
  saveAdv(data, errorback) {
    console.log(data)
    return request._post('/shop/plus.adv.adv/edit', data, errorback);
  },
  /*删除广告*/
  delAdv(data, errorback) {
    return request._post('/shop/plus.adv.adv/delete', data, errorback);
  },
  /*查看商品*/
  seeAdv(data, errorback) {
    return request._post('/shop/plus.adv.adv/see', data, errorback);
  },

  /*等级列表*/
  orderLists(data, errorback) {
    return request._post('/shop/plus.adv.order/index', data, errorback);
},
/*添加等级*/
addOrder(data, errorback) {
    return request._post('/shop/plus.adv.order/add', data, errorback);
},
/*修改等级*/
editOrder(data, errorback) {
    return request._post('/shop/plus.adv.order/edit', data, errorback);
},
/*删除等级*/
deleteorder(data, errorback) {
    return request._post('/shop/plus.adv.order/delete', data, errorback);
},

  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/plus.adv.Setting/index', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.adv.Setting/index', data, errorback);
  },
  /*获取设置*/
    getDiySkill(data, errorback) {
    return request._post('/shop/plus.adv.adv/getDiyProduct', data, errorback);
},
}
export default AdvApi;



// WEBPACK FOOTER //
// ./src/api/adv.js